import { useCallback, useEffect, useMemo, useState } from "react";
import { AuthContext } from "../context/AuthContext";

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({ name: "", password: "" });

  const fetchUser = useCallback(() => {
    const savedUser = JSON.parse(localStorage.getItem("user"));

    if (savedUser) {
      return setUser(savedUser);
    }

    setUser({ name: "", password: "" });
    // Don't auto-redirect here - let ProtectedRoute handle it
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const authValue = useMemo(() => {
    return { ...user, refetch: fetchUser };
  }, [user, fetchUser]);

  return <AuthContext value={authValue}>{children}</AuthContext>;
};

export default AuthProvider;
